import { SvgIcon } from '@mui/material';
import { ResponsiveButton } from 'components/buttons';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { Icons } from 'greener-ui-library';

export const Alerts = () => {
  const { t } = useTranslation();

  return (
    <ResponsiveButton
      data-testid="projects-navigation"
      color="inherit"
      component={RouterLink}
      to="/alerts"
      breakpoint="sm"
      icon={() => (
        <SvgIcon sx={{ fontSize: 24 }}>
          <Icons.Notification />
        </SvgIcon>
      )}
    >
      {t('navigation.alerts')}
    </ResponsiveButton>
  );
};
